"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abstract_filter_item_1 = require("./abstract-filter-item");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
class TextFilterItem extends abstract_filter_item_1.AbstractFilterItem {
    constructor(id, label, onValueChange) {
        super(id, label, onValueChange);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value && value.trim();
        this.onFilterItemChange();
    }
    getFilterTreeDto() {
        if (!this.value) {
            return null;
        }
        const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
        /* If search value enclosed in "", we do filter with that value
           If value is nor enclosed in "" and includes >=0 spaces, we split that value and create contains filter with all split values
         */
        if (this.value.startsWith('"') && this.value.endsWith('"')) {
            let modifiedValue = this.value.slice(1, this.value.length - 1);
            filterBuilder.filterByMeasure(this.id).contains(modifiedValue);
            return filterBuilder.build();
        }
        else {
            const valueParts = this.value.split(' ').filter(value => !!value);
            valueParts.slice(1).reduce((accumulator, nextValue) => accumulator.andMeasure(this.id).contains(nextValue), filterBuilder.filterByMeasure(this.id).contains(valueParts[0]));
            return filterBuilder.build();
        }
    }
}
exports.TextFilterItem = TextFilterItem;
//# sourceMappingURL=text-filter-item.js.map